import React from 'react';
import Modal from '@roo/roo/Modal';
import { getStorage, setStorage } from '@utils/localStorage';
import { getGrayStateByToken, GRAY_AB_TOKEN } from '@utils/grayAB';

import pageJump from '@projects/Shell/utils/pageJump';

const CACHE_KEY = 'CancelOrderRulesRemind';

/** 大纠纷二期-商责取消配送服务费子项 新规宣导 只弹一次 https://km.sankuai.com/collabpage/2250892250#b-5ab2f63616244833aaf5e97837fc6907 */
const CancelOrderRulesRemind = () => {
    const tipsShow =
        getStorage(CACHE_KEY) !== '1' &&
        getGrayStateByToken(GRAY_AB_TOKEN.PRE_ORDER_CANCEL_SERVICE_FEE);
    if (tipsShow) {
        Modal.confirm({
            title: '商责取消收取配送服务费',
            children: (
                <div>
                    <p>为促进平台生态良性发展，避免损害交易的行为发生，平台建立“商责取消收费”规则，针对商家责任导致的订单取消问题，结合配送进度，向商家收取一定比例的配送服务费用，补偿给配送方，旨在为商家提供更好的配送服务。</p>
                </div>
            ),
            confirmText: '了解详情',
            cancelText: '知道了',
            onConfirm: () => {
                pageJump.go('https://collegewm.meituan.com/fweb/#/college/detail?id=6994&contentType=1&utm_content_source=PUSH');
            },
        });
        setStorage(CACHE_KEY, '1');
    }
};

export default CancelOrderRulesRemind;
